import React from 'react';
import { Button, Table, Popconfirm, message, Modal, Popover, Icon } from 'antd';
import ExecuteMgrSider from './ExecuteMgrSider';
import API_URL from '../../common/url';
import VisitMapped from './CrfModal';
import StringUtil from '../../common/StringUtil';
import AjaxRequest from '../../common/AjaxRequest';
import AddModuleDefine from './AddModuleDefine';
import SetModuleDefineOption from './SetModuleDefineOption';
import CasCadeOption from './CasCadeOption';
import SortList from '../common/SortList';
import CutoverModal from './CutoverModal';
import VisitCutOff from './VisitCutOff';
import './style/executeMgr.less';

const confirm = Modal.confirm;
const Title = {
    Type_Visit: '访视记录其他字段',
    Type_Filter: '筛选记录',
    Type_Pre_Filter: '预筛记录',
    Type_Drop: '退出记录',
    Type_Violation: '方案违背',
    Type_SAE: 'SAE记录',
    Type_Drug_Overtemperature: '药物超温',
    Type_Drug_Breakage: '药物破损',
    Type_Instrument_Certificate: '仪器设备校准证书',
    Type_Drug_Blindness: '药物破盲',
    Type_Drug_Inventory: '药物库存量',
};

class Crf extends React.Component {
    state = {
        loading: false,
        dataList: [],
        crfDefineId: '',
        typeName: '',
        //isFilterProcess:0,
    };

    loadData = (typeName) => {
        if (typeName == null || typeName == undefined) {
            typeName = this.state.typeName;
        }
        this.setState({
            loading: true,
        });
        const options = {
            url: `${API_URL.execute.getCategoryTree}`,
            data: {
                typeName,
                isDefine: 1,
            },
            dataType: 'json',
            doneResult: data => {
                this.setState({
                    loading: false,
                    dataList: data.data.tableColumns,
                    crfDefineId: data.data.crfDefineId,
                });
            },
        };
        AjaxRequest.sendRequest(options);
    };

    // queryInvStatus = () => {
    //     const { invId } = sessionStorage;
    //     const options = {
    //         url: `${API_URL.plan.queryInvStatus}`,
    //         data: {
    //             investigationId: invId,
    //             publishStatus: this.published ? 'UNPUBLISHED' : 'PUBLISHED',
    //         },
    //         dataType: 'json',
    //         doneResult: res => {
    //             this.setState({  isFilterProcess: res.isFilterProcess });
    //         },
    //     };
    //     AjaxRequest.sendRequest(options);
    // }

    getColumns = () => {
        const { typeName } = this.props.match.params;
        const columnNames = [{
            title: '序号',
            dataIndex: 'index',
            key: 'index',
            width: 60
        }, {
            title: '字段名称',
            dataIndex: 'moduleDefineName',
            key: 'moduleDefineName',
        }, {
            title: '字段类型',
            dataIndex: 'criteriaDataType',
            key: 'criteriaDataType',
            width: 80
        }, {
            title: '填写方式',
            dataIndex: 'projectDefineWebType',
            key: 'projectDefineWebType',
            render: (text, record) => {
                if (typeName == 'Type_Filter' && record.moduleDefineName == '筛选失败原因') {
                    return '级联下拉框';
                }
                return text;
            }
        }, {
            title: '是否必填',
            dataIndex: 'moduleDefineIsRequired',
            key: 'moduleDefineIsRequired',
            width: 80
        }, {
            title: '可选项',
            dataIndex: 'options',
            key: 'options',
            render: (text, record) => {
                if (record.moduleDefineName == '筛选失败原因') {
                    if (record.uncutModuleDefine) {
                        return <span style={{color:'#F00',cursor:'pointer'}} onClick={() => this.cutover(record)}>待割接选项</span>
                    }
                    return 
                } else {
                    return text;
                }
            }
        }];
        if (typeName == 'Type_Filter') {
            columnNames.push({
                title: '映射访视',
                dataIndex: 'visitMappingValues',
                key: 'visitMappingValues',
                render: (text, record) => {
                    if (text) {
                        return text.map(item => <p>{item}</p>)
                    }
                },
            });
        }

        const disabled = sessionStorage.invStatus == 'COMPLETED';
        columnNames.push({
            title: '操作',
            key: 'operation',
            fixed: 'right',
            width: (typeName == 'Type_Filter') ? 120 : 100,
            render: (text, record, index) => {
                const {
                    projectDefineIsDefault: isDefault, projectDefineWebType: type, moduleDefineName: name,
                    moduleDefineId: id, moduleDefineCode: code, options, 
                } = record;
                const dis = isDefault == '1';
                let disOption = true;
                if (
                    (!dis && (type == '单选' || type == '多选' || type == '下拉框')) ||
                    (typeName == 'Type_Drug_Inventory' && (name == '药物名称' || name == '生产厂家'|| name == '规格'|| name == '储存温度'))
                ) {
                    disOption = false;
                }
                let deleteDis = dis || ((!dis && options) ? true : false);
                return (
                    <span>
                        {
                            !(disabled || dis) ?
                                <a onClick={() => this.edit(id)}>修改</a>
                            :
                                <a disabled={true}>修改</a>
                        }
                        <span className="ant-divider" />
                        {
                            !(disabled || deleteDis) ?
                                <Popconfirm title='确定要删除吗?' onConfirm={() => this.del(id, 0)} okText="确定" cancelText="取消">
                                    <a>删除</a>
                                </Popconfirm>
                            :
                            <a disabled={true}>删除</a>
                        }
                        <span className="ant-divider" />
                        {
                            name == '筛选失败原因' ?
                                <a onClick={() => this.setCasCade(code)}>设置级联可选项</a>
                            :
                                !disOption ?
                                    <a onClick={() => this.setOption(id)}>设置可选项</a>
                                :
                                    <a disabled={true}>设置可选项</a>
                        }
                        {
                            (typeName == 'Type_Filter' && (name == '筛选时间' || name == '随机(入组)时间')) &&
                            <span>
                                <span className="ant-divider" />
                                <a onClick={() => this.setMapped(code, name)}>设置映射</a>
                            </span>
                        }
                    </span>
                );
            },
        });
        return columnNames;
    };

    getCriteriaDataTypeInfo = (criteriaDateType) => {
        if (criteriaDateType == 'DATE') {
            return '时间型'
        }
        if (criteriaDateType == 'NUMBER') {
            return '数值型';
        }
        return '文本型';
    };

    getWebTypeInfo = (dataType, webType, formatValue) => {
        if (dataType == 'NUMBER') {
            return '文本框(数字格式：' + (formatValue ? formatValue : '0') + ')';
        }
        if (dataType == 'DATE') {
            if (formatValue == 'YYYY-MM-DD HH:MI') {
                return '时间控件(年月日时分)';
            }
            if (formatValue == 'YYYY-MM') {
                return '时间控件(年月)';
            }
            return '时间控件(年月日)';
        }
        if (webType == 'RADIO') {
            return '单选';
        }
        if (webType == 'CHECKBOX') {
            return '多选';
        }
        if (webType == 'INPUT') {
            return '文本框';
        }
        if (webType == 'TEXTAREA') {
            return '文本域';
        }
        if (webType == 'SELECT') {
            return '下拉框';
        }
        return '未知格式';
    };

    handleModuleDefineAction = (value, confirm) => {
        if (confirm == null || confirm == undefined) {
            confirm = 0;
        }
        const { crfDefineId } = this.state;
        const { typeName } = this.props.match.params;
        if (value.moduleDefineId == 0) {
            const dataObj = {
                datas: [{ ...value }],
            };
            const options = {
                url: `${API_URL.execute.addExecuteDefine}`,
                data: {
                    investigationId: sessionStorage.invId,
                    typeName,
                    crfDefineId,
                    confirm,
                    datas: JSON.stringify(dataObj),
                },
                method: 'POST',
                dataType: 'json',
                doneResult: (data => {
                    if (confirm == 0 && data.confirmError) {
                        this.showConfirm(value, data.confirmError);
                    } else {
                        this.loadData(typeName);
                    }
                }),
                errorResult: () => {
                    this.setState({ loading: false });
                },
            };
            AjaxRequest.sendRequest(options);
        } else {
            const options = {
                url: `${API_URL.execute.updateExecuteDefine}`,
                data: {
                    moduleDefineId: value.moduleDefineId,
                    moduleDefineName: value.moduleDefineName,
                    typeName,
                    moduleDefineCode: value.moduleDefineCode,
                    projectDefineWebType: value.projectDefineWebType,
                    moduleDefineIsRequired: value.moduleDefineIsRequired,
                    formatValue: value.formatValue,
                },
                dataType: 'json',
                doneResult: () => {
                    message.success("设置成功");
                    this.loadData(typeName);
                },
                errorResult: () => {
                    this.setState({ loading: false });
                },
            };
            AjaxRequest.sendRequest(options);
        }
    };

    showConfirm = (value, content) => {
        confirm({
            title: '确认添加',
            content: content,
            onOk: () => {
                this.handleModuleDefineAction(value, 1);
            },
        });
    }

    handleModuleDefineOptionAction = (dataList, moduleDefineId, investigationExecuteDefineId) => {
        let params = {};
        dataList.forEach((item, index) => {
            params[`arrays[${index}]`] = item.text;
        });

        const url = API_URL.execute.updateExecuteDefineOption;
        const { typeName } = this.props.match.params;

        const options = {
            url,
            data: {
                moduleDefineId,
                typeName,
                ...params,
            },
            dataType: 'json',
            doneResult: () => {
                message.success("设置成功");
                this.loadData(typeName);
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        AjaxRequest.sendRequest(options);
    };

    getDataSource = () => {
        const resList = [];
        const { dataList } = this.state;
        let idx = 1;
        dataList.map((dataItem, i) => {
            if (dataItem.moduleDefineName != '录入者') {
                resList.push({
                    index: idx,
                    moduleDefineId: dataItem.moduleDefineId,
                    criteriaDefineId: dataItem.criteriaDefineId,
                    moduleDefineName: dataItem.moduleDefineName,
                    moduleDefineCode: dataItem.moduleDefineCode,
                    criteriaDataType: this.getCriteriaDataTypeInfo(dataItem.criteriaDataType),
                    projectDefineWebType: this.getWebTypeInfo(dataItem.criteriaDataType, dataItem.projectDefineWebType, dataItem.formatValue),
                    moduleDefineIsRequired: dataItem.moduleDefineIsRequired == '1' ? '是' : '否',
                    projectDefineIsDefault: dataItem.projectDefineIsDefault,
                    options: dataItem.moduleDefineConstraintValue ? StringUtil.replaceAll(dataItem.moduleDefineConstraintValue, '//', ';') : '',
                    visitMappingValues: dataItem.visitMappingValues,
                    uncutModuleDefine: dataItem.uncutModuleDefine,
                });
                idx++;
            }
        });
        return resList;
    };

    add = () => {
        // const { isFilterProcess } = this.state;
        // if(isFilterProcess)
        // {
        //     message.warning("本项目未发布访视周期计划，不可添加记录；");
        //     return;
        // }
        this.addModuleDefineRef.show();
    }

    sort = () => {
        const { dataList } = this.state;
        const sortList = [];
        dataList.map((item, index) => {
            if (!(index == 0 && item.moduleDefineName == '筛选编号') && item.moduleDefineName != '录入者') {
                sortList.push({
                    key: item.moduleDefineCode,
                    name: item.moduleDefineName,
                });
            }
        });
        this.sortListRef.show(sortList);
    }

    edit = id => {
        const { dataList } = this.state;
        // const { isFilterProcess } = this.state;
        // if(isFilterProcess)
        // {
        //     message.warning("本项目未发布访视周期计划，不可修改数据；");
        //     return;
        // }
        dataList.map((dataItem, i) => {
            if (dataItem.moduleDefineId == id) {
                this.addModuleDefineRef.show(dataItem, 1);
            }
        });
    }

    del = (id, confirm) => {
        // const { isFilterProcess } = this.state;
        // if(isFilterProcess)
        // {
        //     message.warning("项目未发布访视周期计划，不可删除记录;");
        //     return;
        // }
        const { typeName } = this.props.match.params;
        const options = {
            url: `${API_URL.execute.deleteExecuteDefine}`,
            data: {
                moduleDefineId: id,
                typeName,
                confirm,
            },
            dataType: 'json',
            doneResult: (data => {
                if (data.confirmError) {
                    this.confirmDel(id, data.confirmError);
                } else {
                    this.loadData(typeName);
                }
            }),
        };
        AjaxRequest.sendRequest(options);
    }

    confirmDel = (id, confirmError) => {
        Modal.confirm({
            iconType: 'exclamation-circle',
            title: confirmError,
            onOk: () => {
                this.del(id, 1);
            },
        });
    }

    setOption = id => {
        const { dataList } = this.state;
        dataList.map((dataItem, i) => {
            if (dataItem.moduleDefineId == id) {
                this.setModuleDefineOptionRef.show(dataItem, 1);
            }
        });
    }

    setMapped = (moduleDefineCode, moduleDefineName) => {
        this.VisitMappedRef.show(moduleDefineCode, moduleDefineName);
    }

    componentDidMount() {
        const { typeName } = this.props.match.params;
        this.setState({ typeName });
        this.loadData(typeName);
        //this.queryInvStatus();
    }

    componentWillReceiveProps(nextProps) {
        const { typeName } = nextProps.match.params;
        this.setState({
            typeName: typeName,
        });
        this.loadData(typeName);
    }

    setCasCade = moduleDefineCode => {
        this.CasCadeOptionRef.show(moduleDefineCode);
    }

    cutover = (record) => {
        this.cutoverModalRef.show(record);
    }

    showVisitCutOff = (type) => {
        this.setState({
            showCutOff: false,
        }, () => {
            this.visitCutOffRef.show(type);
        });
    }

    render() {
        const { dataList, showCutOff = false } = this.state;
        const { loading, match } = this.props;
        const { typeName } = match.params;
        const name = Title[typeName];
        const { curRole, invStatus, investigationSiteName } = sessionStorage;
        const disabled = invStatus == 'COMPLETED';
        const isShow = !investigationSiteName && (curRole == 'PA' || curRole == 'PM' || curRole == 'CTA');
        let contentNode;
        if (name == '筛选记录') {
            contentNode = (
                <span>
                    一、“筛选失败原因”级联选项设置<br />
                    1.点击“筛选失败原因”记录的操作“设置级联可选项”，可以自行<br />
                    设置筛选失败原因选项；<br />
                    2.可以添加一级选项；<br />
                    3.在一级选项上点击添加操作，可以添加二级选项，在二级选项<br />
                    上点击添加操作，可以添加三级选项，以此类推，最多添加至第<br />
                    六层；<br />
                    4.一级/二级默认选项不能修改、删除；<br />
                    5.选中某级自定义添加的选项，点击修改操作，可以修改该选项；<br />
                    6.选中某级自定义添加的选项，点击删除操作，可以删除该选项<br />
                    （若该选项后还有层级，将一起删除）；<br />
                    7.点击筛选失败原因的“待割接选项”，可以将线上已填写的选项<br />
                    迁入级联可选项；<br />
                    二、“筛选时间”、“随机（入组）时间”映射至访视次数<br />
                    1.点击“筛选时间”、“随机（入组）时间”记录的操作“设置映射”，<br />
                    可以将该字段值映射到某个访视次数中，即映射的访视次数的实<br />
                    际时间自动填充。
                </span>
            );
        } else if (name == '访视记录其他字段') {
            contentNode = (
                <span style={{ color: '#FF0' }}>
                    注意：在录入任何访视记录前，请先进行访视周期计划设置。<br />
                    只有设置了访视周期计划，才能录入访视
                </span>
            )
        }
        return (
            <div className="content">
                <ExecuteMgrSider selectKey={typeName} />
                <div className="main">
                    <div className="breadcrumb-bar tac">
                        {
                            isShow && (name == '筛选记录' || name == '访视记录其他字段') &&
                            <Popover placement="right" overlayClassName="propercent-pop" content={contentNode}>
                                <div style={{ float: 'left' }}>
                                    <Icon type="info-circle" style={{ color: '#5750c9', marginRight: 4 }} />
                                    <a>配置说明</a>
                                </div>
                            </Popover>
                        }
                        <h2 className="title">{name}</h2>
                    </div>
                    <div className="filter-bar tar">
                        <Button type="primary" onClick={this.sort}>排序调整</Button>
                        <Button type="primary" disabled={disabled} onClick={this.add}>添加</Button>
                        {
                            name == '访视记录其他字段' &&
                            <div style={{ position: 'absolute', right: 0 }}>
                                <Button style={{color: '#fff', background: '#f04134'}} onClick={() => {this.setState({ showCutOff: !showCutOff })}}>自定义字段割接调整</Button>
                                <ul className="visit-cut-list" style={{ display: showCutOff ? 'block' : 'none' }}>
                                    <li className="visit-cut-item" onClick={() => this.showVisitCutOff('DATE')}>时间型字段割接</li>
                                    <li className="visit-cut-item" onClick={() => this.showVisitCutOff('TEXT')}>文本型字段割接</li>
                                </ul>
                            </div>
                        }
                    </div>
                    <div className="main-content">
                        <Table
                            columns={this.getColumns()}
                            dataSource={this.getDataSource()}
                            rowKey={record => record.moduleDefineId}
                            loading={loading}
                            pagination={false}
                        />
                    </div>
                </div>
                <VisitMapped ref={el => this.VisitMappedRef = el} loadData={this.loadData} />
                <AddModuleDefine
                    ref={el => this.addModuleDefineRef = el}
                    handleModuleDefineAction={this.handleModuleDefineAction}
                />
                <SetModuleDefineOption
                    ref={el => this.setModuleDefineOptionRef = el}
                    handleModuleDefineOptionAction={this.handleModuleDefineOptionAction}
                />
                <SortList
                    ref={el => this.sortListRef = el}
                    reload={this.loadData}
                    sortUrl={`${API_URL.execute.sortExecuteDefine}`}
                    title={name + "-排序调整"}
                    data={{ typeName, }}
                />
                <CasCadeOption ref={el => this.CasCadeOptionRef = el} />
                <CutoverModal ref={el => this.cutoverModalRef = el} loadData={() => this.loadData(typeName)} />
                <VisitCutOff ref={el => this.visitCutOffRef =el} moduleDefineList={dataList} loadData={() => this.loadData(typeName)} />
            </div>
        );
    }
}

export default Crf;



// WEBPACK FOOTER //
// ./src/components/executeMgr/Crf.js